// Valid email must have local-part@domain.tld
// Rejects: only chars with no @, only numbers, only special chars, spaces
const EMAIL_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9._%+\-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9\-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,})+$/;

export const validateEmail = (value) => {
    if (!value || !value.trim()) {
        return { message: 'Email is required', valid: false };
    }
    if (/\s/.test(value)) {
        return { message: 'Email should not contain spaces', valid: false };
    }
    if (value.trim().length > 100) {
        return { message: 'Email should not exceed 100 characters', valid: false };
    }
    if (!EMAIL_REGEX.test(value.trim())) {
        return { message: 'Enter a valid email address', valid: false };
    }
    return { message: '', valid: true };
};
